const initialState = {
  newsList: [],
  newsListSearch: [],
  newsDetail: {},
  newsId: null,
  searchTerm: '',
  searchPage: {
    page: 1,
    size: 5,
  }
};

const newsReducer = (state = initialState, action) => {
  switch (action.type) {
      case 'SET_NEWS_LIST':
        return { ...state, newsList: action.newsList };
      case 'SET_NEWS_LIST_SEARCH':
        return { ...state, newsListSearch: action.newsListSearch };
      case 'SET_NEWS_DETAIL':
          return { ...state, newsDetail: action.newsDetail };
      case 'SET_SEARCHTERM':
          return { ...state, searchTerm: action.searchTerm };
      case 'SET_SEARCHPAGE':
          return { ...state, searchPage: action.searchPage };
      default:
          return state;
  }
}

export { newsReducer as default }